// Utility function to truncate text at word boundaries
const truncateText = (text: string, maxTextLength = 110): string => {
  if (text.length <= maxTextLength) return text

  const ellipsis = '...'

  // If max length is less than ellipsis length, just return ellipsis
  if (maxTextLength <= ellipsis.length) {
    return ellipsis
  }

  const truncated = text.substring(0, maxTextLength - ellipsis.length)
  const lastSpaceIndex = truncated.lastIndexOf(' ')

  // Avoid cutting words in half - find last complete word
  const cutPoint = lastSpaceIndex > 0 ? lastSpaceIndex : truncated.length
  return text.substring(0, cutPoint) + ellipsis
}

export default truncateText
